// src/hooks/useActivityTracker.ts
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../types";
import api from "../api/api";

const DEBOUNCE_MS = 30_000;

/**
 * Tracks authenticated page visits by posting to the activity API.
 * Debounced: at most 1 event per path per 30 seconds.
 */
const useActivityTracker = () => {
  const location = useLocation();
  const isAuthenticated = useSelector((state: RootState) => !!state.auth.token);
  const sentRef = useRef<Record<string, number>>({});

  useEffect(() => {
    if (!isAuthenticated) return;

    const path = location.pathname;
    const now = Date.now();
    const last = sentRef.current[path] || 0;
    if (now - last < DEBOUNCE_MS) return;
    sentRef.current[path] = now;

    api
      .post("/billing/admin/activity/", { path, resource_type: "page" })
      .catch(() => {});
  }, [location.pathname, isAuthenticated]);
};

export default useActivityTracker;
